const server =  {
    REQUEST_RESTART_APPLICATION: "REQUEST_RESTART_APPLICATION",
    END_REQUEST_RESTART_APPLICATION: "END_REQUEST_RESTART_APPLICATION",
    ERROR_REQUEST_RESTART_APPLICATION: "ERROR_REQUEST_RESTART_APPLICATION",
    REQUEST_CLEAR_CACHE: "REQUEST_CLEAR_CACHE",
    END_REQUEST_CLEAR_CACHE: "END_REQUEST_CLEAR_CACHE",
    ERROR_REQUEST_CLEAR_CACHE: "ERROR_REQUEST_CLEAR_CACHE"  
};

export default server;